import React from 'react';
import _ from 'lodash';
import { simpleDateNoTime, parseAmount, formatAmount } from 'app/utils/parsers';
import history from 'app/routes/history';
import Button from 'app/components/general/Button';
import SectionGroup from 'app/components/general/SectionGroup';
import ModalConfirm from 'app/components/general/ModalConfirm';
import Notification from 'app/components/general/Notification';
import PaymentCardMin from 'app/components/matches/PaymentCardMin';
import classnames from 'classnames';
import * as paymentEventsSelectors from 'app/ducks/paymentEvents/selectors';
import Isvg from 'react-inlinesvg';
import ManagerIcon from 'app/images/icons/crown.svg';

interface IStep4ConfirmProps {
  isValid: Function;
  handleChange: Function;
  handleSubmit: Function;
  formData: any;
  actions: any;
  payeeType: string;
  errors: any;
  appReady: boolean;
  changed: boolean;
  teamPaymentRequests: any;
  originalFormData: any;
  selectedRows: any;
  teamMembers: any;
  totalAmount: string;
  currentPaymentEvent: any;
  groupId: string;
  rows: any[];
}

interface IStep4ConfirmState {
  submitModalOpen: boolean;
}

export default class Step4Confirm extends React.Component<IStep4ConfirmProps, IStep4ConfirmState> {
  static defaultProps: IStep4ConfirmProps = {
    actions: undefined,
    formData: undefined,
    payeeType: '',
    appReady: false,
    changed: false,
    teamPaymentRequests: undefined,
    originalFormData: undefined,
    isValid: undefined,
    handleChange: undefined,
    handleSubmit: undefined,
    selectedRows: undefined,
    teamMembers: {},
    totalAmount: '',
    errors: undefined,
    rows: [],
  };

  state = {
    submitModalOpen: false,
  }

  handleBack = () => {
    history.push(`/payment-requests/new/select:${this.props.match.params.preconfigData}`);
  };

  handleOpenSubmitModal = (): void => {
    this.setState({ submitModalOpen: true });
  }

  handleCloseSubmitModal = (): void => {
    this.setState({ submitModalOpen: false });
  }

  parseSelectedPayeeText = (number, type): string => {
    const parsedNumber = number > 0 ? number : 0;
    const parsedText = `${parsedNumber.toString()} team member`;
    const finalText = number !== 1 ? `${parsedText}s` : parsedText;
    return finalText;
  }

  // parseInitialNotificationText = (sendEmailNotification, sendSMSNotification): string => {
  //   if (sendEmailNotification && sendSMSNotification) {
  //     return 'Email, SMS';
  //   } if (sendEmailNotification && !sendSMSNotification) {
  //     return 'Email';
  //   } if (!sendEmailNotification && sendSMSNotification) {
  //     return 'SMS';
  //   }
  //   return '';
  // }

  // parseReminderText = (sendEmailReminders, sendSMSReminders): string => {
  //   if (sendEmailReminders && sendSMSReminders) {
  //     return 'Yes (Email, SMS)';
  //   } if (sendEmailReminders && !sendSMSReminders) {
  //     return 'Yes (Email)';
  //   } if (!sendEmailReminders && sendSMSReminders) {
  //     return 'Yes (SMS)';
  //   }
  //   return 'No';
  // }

  renderSubmitModal = (): React.ReactNode => (
    <ModalConfirm
      title="Send payment request"
      description="This will send out notifications to all selected team members immediately."
      buttonText="Send"
      isOpen={this.state.submitModalOpen}
      isLoading={this.props.teamPaymentRequests.isSaving}
      hasFailed={this.props.teamPaymentRequests.hasFailed}
      hasSaved={this.props.teamPaymentRequests.hasSaved}
      handleSubmit={this.props.handleSubmit}
      handleCancel={this.handleCloseSubmitModal}
    />
  );

  renderTeamMemberRow = (row): React.ReactNode => {
    if (row.id === 'teamManager') {
      return (
        <div className="row with-margin-bottom-10">
          <div className="col col-6">
            <div className="d-inline-flex align-items-center justify-content-center">
              {row?.id === 'teamManager' && (
                <Isvg src={ManagerIcon} className="d-inline-block float-left icon-small icon-primary margin-right-5" />
              )}
              {row?.name}
            </div>

            {' '}
            {row.id === 'teamManager' && <span className="text-weight-medium-bold">(Team Manager)</span>}

          </div>
          <div className="col col-6">
            {formatAmount(row.amount)}
            {' '}
            {row.id === 'teamManager' && <span className="text-weight-medium-bold">(Deducted)</span>}
          </div>
        </div>
      );
    }
    return (
      <div className="row with-margin-bottom-10">
        <div className="col col-6">
          <div className="d-inline-flex align-items-center justify-content-center">
            {`${this.props.teamMembers?.teamMembersById[row.id]?.fullName}`}
          </div>

        </div>
        <div className="col col-6">
          {formatAmount(row.amount)}
        </div>
      </div>
    );
  }

  render(): React.ReactNode {
    const selectedPayeeText = this.parseSelectedPayeeText(_.filter(this.props.rows, (row) => row.selected && row.id !== 'teamManager').length, this.props.payeeType);
    return (
      <div>
        <div className="row">
          <div className="col">
            {this.props.children}
          </div>
        </div>
        {!_.isEmpty(this.props.currentPaymentEvent) && !_.isEmpty(this.props.groupId) && (
          <div className="row with-margin-bottom with-margin-top">
            <div className="col">
              <SectionGroup title="Selected Match">
                <div className="row">
                  <div className="col">
                    <PaymentCardMin
                      {...paymentEventsSelectors.getPaymentEventForMatchCard(
                        this.props.currentPaymentEvent,
                        this.props.groupId,
                      )}
                      truncated
                    />
                  </div>
                </div>

              </SectionGroup>
            </div>
          </div>
        )}
        <div className="row with-margin-top">
          <div className="col">
            <SectionGroup title="Confirm Payment Request">
              <div className="row">
                <div className="col col-4">
                  Payment type
                </div>
                <div className="col text-weight-medium-bold">
                  {this.props.formData.paymentType?.name}
                </div>
              </div>
              <div className="row with-margin-top-10">
                <div className="col col-4">
                  Payment description
                </div>
                <div className="col text-weight-medium-bold">
                  {this.props.formData.description}
                </div>
              </div>
              {/* <div className="row with-margin-top-10">
                <div className="col col-4">
                  Amount
                </div>
                <div className="col text-weight-medium-bold">
                  {this.props.formData.amount}
                </div>
              </div> */}
              <div className="row with-margin-top-10">
                <div className="col col-4">
                  Due date
                </div>
                <div className="col text-weight-medium-bold">
                  {this.props.formData.dueDate !== undefined ? simpleDateNoTime(this.props.formData.dueDate[0]) : ''}
                </div>
              </div>
              <div className="row with-margin-top-10">
                <div className="col col-4">
                  Initial notification
                </div>
                <div className="col text-weight-medium-bold">
                  SMS
                </div>
              </div>
              <div className="row with-margin-top-10">
                <div className="col col-4">
                  Collecting amount
                </div>
                <div className="col text-weight-medium-bold">
                  {parseAmount(this.props.totalAmount.amount)}
                </div>
              </div>
            </SectionGroup>
          </div>
        </div>
        <div className="row with-margin-top">
          <div className="col">
            <SectionGroup title="Selected Team Members">
              <div className="row with-margin-bottom-15">
                <div className="col col-6">
                  <span className="text-weight-medium-bold">
                    Team Member
                  </span>
                </div>
                <div className="col col-6">
                  <span className="text-weight-medium-bold">
                    Amount
                  </span>
                </div>
              </div>
              {_.map(_.filter(this.props.rows, (row) => row.selected && row.id === 'teamManager'), (row) => this.renderTeamMemberRow(row))}
              {_.map(_.filter(this.props.rows, (row) => row.selected && row.id !== 'teamManager'), (row) => this.renderTeamMemberRow(row))}
            </SectionGroup>
          </div>
        </div>
        <div className={classnames('row with-margin-top', { 'd-none': this.props.currentPaymentEvent?.id === undefined })}>
          <div className="col">
            <Notification>
              <div className="d-inline-block">
                <span className="text-weight-medium-bold">Reminder: </span>
                This does not automatically pay for your match. You will need to pay for your match separately.
              </div>
            </Notification>
          </div>
        </div>
        {this.renderSubmitModal()}
        <div className="row with-margin-top">
          <div className="col btn-flex-group">
            <div className="btn-flex-container">
              <Button
                className="btn-standard btn-1"
                type="submit"
                noLoading
                // isLoading={this.props.teamPaymentRequests.isSaving}
                hasSaved={this.props.teamPaymentRequests.hasSaved}
                hasFailed={this.props.teamPaymentRequests.hasFailed}
                onClick={this.handleOpenSubmitModal}
              >
                Send Payment Request
              </Button>
              <Button onClick={this.handleBack} className="btn-standard btn-2">Back</Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
